import { Controller } from '@hotwired/stimulus';

// TODO improve focus management

export default class extends Controller {
  connect() {
    this.element.addEventListener('close', this.handleClose);
    this.element.showModal();
  }

  close() {
    this.element.close();
  }

  handleClose = () => {
    this.element.remove();
  };
}
